import "core-js/modules/es.symbol";
import "core-js/modules/es.symbol.description";
import "core-js/modules/es.symbol.iterator";
import "core-js/modules/es.array.concat";
import "core-js/modules/es.array.iterator";
import "core-js/modules/es.date.to-string";
import "core-js/modules/es.object.create";
import "core-js/modules/es.object.define-property";
import "core-js/modules/es.object.get-prototype-of";
import "core-js/modules/es.object.set-prototype-of";
import "core-js/modules/es.object.to-string";
import "core-js/modules/es.reflect.construct";
import "core-js/modules/es.regexp.to-string";
import "core-js/modules/es.string.iterator";
import "core-js/modules/web.dom-collections.iterator";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/*
 * Copyright (c) 2018 Wells Fargo. 45 Fremont Street, San Francisco, CA 94105 All rights reserved.
 *
 *This software is the confidential and proprietary information of Wells Fargo
 *bank. ('Confidential Information'). You shall not disclose such Confidential
 *Information and shall use it only in accordance with the terms of the license
 *agreement you entered into with WellsFargo.
 *
 *Author: Thomas Barry
*/

/* eslint-disable camelcase */
import React from 'react';
import { connect } from 'react-redux';
import { fireAndForget } from 'wfui-digital-core/es/lib';
import sendBusinessEvent from '../../lib/business-events/business-events';
import globals from '../../lib/globals/globals';
import logger from '../../lib/logger/logger';

var Foresee = /*#__PURE__*/function (_React$Component) {
  _inherits(Foresee, _React$Component);

  var _super = _createSuper(Foresee);

  function Foresee() {
    var _this;

    _classCallCheck(this, Foresee);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "handleInviteAccepted", function () {
      sendBusinessEvent('feedback_inviteAccepted');
      document.removeEventListener('wf.foresee_inviteaccepted', _this.handleInviteAccepted);
    });

    _defineProperty(_assertThisInitialized(_this), "handleInviteAbandoned", function () {
      sendBusinessEvent('feedback_inviteAbandoned');
      document.removeEventListener('wf.foresee_inviteabandoned', _this.handleInviteAbandoned);
    });

    _defineProperty(_assertThisInitialized(_this), "handleInviteDeclined", function () {
      sendBusinessEvent('feedback_inviteDeclined');
      document.removeEventListener('wf.foresee_invitedeclined', _this.handleInviteDeclined);
    });

    _defineProperty(_assertThisInitialized(_this), "handleInviteShown", function () {
      globals().solicitReactionShownUrl && fireAndForget({
        url: globals().solicitReactionShownUrl
      });
      window.utag_data.isSolicitReactionShown = 'true';
    });

    return _this;
  }

  _createClass(Foresee, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      if ((globals().foresee || {}).enabled) {
        logger.info('Foresee mounted');
        document.addEventListener('wf.foresee_inviteaccepted', this.handleInviteAccepted);
        document.addEventListener('wf.foresee_inviteabandoned', this.handleInviteAbandoned);
        document.addEventListener('wf.foresee_invitedeclined', this.handleInviteDeclined);
        document.addEventListener('wf.foresee_inviteshown', this.handleInviteShown);
      }
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      var workflowActive = this.props.workflowActive; // Suppress foresee when a workflow is active

      if (window.utag && window.utag_data && workflowActive !== prevProps.workflowActive) {
        window.utag_data.foresee_suppress = workflowActive;
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      if ((globals().foresee || {}).enabled) {
        document.removeEventListener('wf.foresee_inviteaccepted', this.handleInviteAccepted);
        document.removeEventListener('wf.foresee_inviteabandoned', this.handleInviteAbandoned);
        document.removeEventListener('wf.foresee_invitedeclined', this.handleInviteDeclined);
        document.removeEventListener('wf.foresee_inviteshown', this.handleInviteShown);
      }
    }
  }, {
    key: "render",
    value: function render() {
      return null;
    }
  }]);

  return Foresee;
}(React.Component);

var mapStateToProps = function mapStateToProps(state) {
  return {
    workflowActive: state.core.workflow.details.active === true
  };
};

export default connect(mapStateToProps)(Foresee);